import {Card} from "react-bootstrap";
import {TxtSuspense} from "_components/suspense/parts";
import {HStack, VStack} from "_ui/Box";
import {DatePickerSuspense} from "_components/suspense/DatePickerSuspense";
import {ButtonSuspense} from "_components/suspense/ButtonSuspense";
import {Page} from "_page/Page";

export const SuspenseHoursAvailable = () => {
    return (
        <Page>
            <Card>
                <Card.Body>
                    <VStack g={2}>
                        <TxtSuspense w={250} h={30}/>
                        <TxtSuspense w={150}/>
                        <HStack g={2} wFull>
                            <DatePickerSuspense/>
                            <VStack>
                                <TxtSuspense w={50}/>
                                <ButtonSuspense w={250}/>
                            </VStack>
                        </HStack>
                    </VStack>
                </Card.Body>

                <Card.Footer>
                    <ButtonSuspense />
                </Card.Footer>
            </Card>
        </Page>
    );
}
